export const getScrollingParent = (node: HTMLElement | null): HTMLElement | null => {
  if (node == null) {
    return null
  }

  if (node === document.body) {
    return node
  }

  // Check if the element can scroll vertically
  const { overflowY } = window.getComputedStyle(node)
  if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
    return node
  }

  return getScrollingParent(node.parentNode as HTMLElement)
}
